var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"App-textfield mdl-textfield"},[_c('label',{staticClass:"mdl-textfield__label perm-label",attrs:{"for":"textfield"}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"App-textfield__input",domProps:{"innerHTML":_vm._s(_vm.formatSemicolonLinebreak)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }